/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreProjectSubtaskResponseDto } from '../../models/core-project-subtask-response-dto';
import { CoreProjectSubtaskUpdateDto } from '../../models/core-project-subtask-update-dto';

export interface ProjectSubtasksControllerUpdate$Params {

/**
 * The tenant identifier.
 */
  tenant: string;

/**
 * The ID of the project subtask to update.
 */
  id: string;
      body: CoreProjectSubtaskUpdateDto
}

export function projectSubtasksControllerUpdate(http: HttpClient, rootUrl: string, params: ProjectSubtasksControllerUpdate$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreProjectSubtaskResponseDto>> {
  const rb = new CoreRequestBuilder(rootUrl, projectSubtasksControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<CoreProjectSubtaskResponseDto>;
    })
  );
}

projectSubtasksControllerUpdate.PATH = '/o2-core/project-subtasks/{tenant}/{id}';
